import { render, staticRenderFns } from "./ChatMessage.vue?vue&type=template&id=7d8c218e&scoped=true&"
import script from "./ChatMessage.vue?vue&type=script&lang=ts&"
export * from "./ChatMessage.vue?vue&type=script&lang=ts&"
import style0 from "./ChatMessage.vue?vue&type=style&index=0&id=7d8c218e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8c218e",
  null
  
)

export default component.exports